import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, HashRouter} from 'react-router-dom';
import './index.css';

import ErrorBoundary from './components/error-boundary/ErrorBoundary';
import {store} from './store/store';
import App from './App';

window.addEventListener('error', (event) => {
    console.error('JavaScript Error:', event.message);
});

window.addEventListener('unhandledrejection', (event) => {
    console.error('Promise Rejection:', event.reason);
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <ErrorBoundary>
        <Provider store={store}>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </Provider>
    </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
